import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {BeroepenPaginaAppModule} from './app/beroepen-pagina-app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(BeroepenPaginaAppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
